import { z } from 'zod';

import { errorMessage } from '../config';

export type RestoreSchema = z.infer<typeof restoreData>;
export type RestoreErrors = z.inferFlattenedErrors<
	typeof restoreData
>['fieldErrors'];

export type RestoreConfirmSchema = z.infer<typeof restoreConfirmData>;
export type RestoreConfirmErrors = z.inferFlattenedErrors<
	typeof restoreConfirmData
>['fieldErrors'];

export const restoreData = z.object({
	email: z.string().email(errorMessage.email_invalid),
});

export const restoreConfirmData = restoreData
	.extend({
		password: z
			.string()
			.min(8, errorMessage.password_too_short)
			.refine(
				(arg) => !/[^a-zA-Z0-9!@#$%^&*+_=-]/.test(arg),
				errorMessage.password_invalid,
			),
		confirmPassword: z.string(),
		verificationCode: z.string().length(6, errorMessage.otp_not_matched),
	})
	.refine((data) => data.password === data.confirmPassword, {
		message: errorMessage.password_not_match,
		path: ['confirmPassword'],
	});
